import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import { NoNetwork } from '../icons';
import OnboardContent from '../onboarding/OnboardContent';

import { useNavigation } from '../../context/NavigationContext';
import { useNavigate } from 'react-router-dom';
import { Button } from '../Ant';
import { usePage } from '../../context/PageContext';
import { showToast } from '../utils/toast';

const NoInternet = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { lastPage } = useNavigation();
  const { setTitle, setActions } = usePage();
  const handleRetry = () => {
    if (!navigator.onLine) {
      showToast('error', t('common:noInternetConnectionDetected'));
      return;
    }
    navigate(lastPage);
  };

  useEffect(() => {
    setTitle(t('common:noInternet'));
    setActions(null);
  }, [t]);

  return (
    <div className="d-flex justify-center flex-col items-center h-full pb-gutter">
      <OnboardContent
        data-testid="no-internet-onboard-content"
        title={t('common:noInternetConnectionDetected')}
        icon={<NoNetwork />}
      />
      <div className="d-flex justify-between w-full">
        <Button
          data-testid="no-internet-retry-button"
          size="large"
          block
          type="primary"
          onClick={handleRetry}
        >
          {t('common:retry')}
        </Button>
      </div>
    </div>
  );
};

export default NoInternet;
